import { Routes as RouterRoutes, Route } from 'react-router-dom';
import { Routes as DDRoutes } from '@datadog/browser-rum-react/react-router-v6'
import NavbarWrapper from './components/Navbar';
import EDCTTable from './components/EDCTTable';
import TMUWrapper from './components/TMUWrapper';
import EDCTLadderWrapper from './components/EDCTLadderWrapper';
import ConfigLadders from './components/ConfigLadders';
import ConfigStreams from './components/ConfigStreams';
import ConfigStars from './components/ConfigStars';
import Privacy from './components/Privacy';
import NotFoundPage from './components/NotFoundPage';
import HomePage from './components/HomePage'
import Login from './components/Login';
import ConfigFacilities from './components/ConfigFacilities';
import ConfigAirports from './components/ConfigAirports';
import Profile from './components/Profile';
import Status from './components/Status';
import ConfigRestrictions from './components/ConfigRestrictions';
import FacilityAdmin from './components/FacilityAdmin';
import ConfigUsers from './components/ConfigUsers';
import AirportAdmin from './components/AirportAdmin';

function Routes({ children }){
  if (process.env.REACT_APP_DD_RUM_ENABLED.toLowerCase() === 'true'){
    return (
        <DDRoutes>
          {children}
        </DDRoutes>
    )
  }
  return (
      <RouterRoutes>
        {children}
      </RouterRoutes>
  )
}

// TODO add error catch-all component route
function App() {
  return (
    <div>
      <NavbarWrapper />
      <Routes>
        <Route path="/loginverify" element={<Login/>} />
        <Route path="/profile" element={<Profile/>} />
        <Route path="/status" element={<Status/>} />
        <Route path="/privacy" element={<Privacy/>} />
        <Route path="/tmu/:icao" element={<TMUWrapper/>}/>
        <Route path="/edct/:icao" element={<EDCTLadderWrapper/>}/>
        <Route path="/configstreams" element={<ConfigStreams/>}/>
        <Route path="/configladders" element={<ConfigLadders/>}/>
        <Route path="/configstars" element={<ConfigStars/>}/>
        <Route path="/configusers" element={<ConfigUsers/>}/>
        <Route path="/configfacilities" element={<ConfigFacilities/>}/>
        <Route path="/configairports" element={<ConfigAirports/>}/>
        <Route path="/configrestrictions" element={<ConfigRestrictions/>}/>
        <Route path="/clearance/:airport" element={<EDCTTable/>}/>
        <Route path="/facilityadmin/:facilityID" element={<FacilityAdmin/>}/>
        <Route path="/airportadmin/:airportID" element={<AirportAdmin/>}/>

        <Route exact path="/" element={<HomePage/>}/>
        <Route path="*" element={<NotFoundPage/>}/>
      </Routes>
    </div>
  );
}

export default App;
